/* eslint-disable array-bracket-newline */
import { useSelector } from 'react-redux';
import { Network } from '@kattana-io/common';
import TradingPlaceholder from './common/TradingPlaceholder';
import DexTrading from './sections';
import useDevice from '../../pages/MainPage/useMobileDetect';
import { IStore } from '../../reducers';
import { getNetworkFlags } from '../../wallet/helpers';

const cexTradingPlaceholder = 'Trading is not available for CEX yet';
const elrondTronPlacholder = 'Trading is not available on this chain yet';

const supportedEVMTradingChains = [1, 56, 137, 250, 42161, 43114, 10];

export const LS_TRADING_HEIGHT = 'kattana-simple.trading_height';

const getSavedHeight = () => {
  const value = localStorage.getItem(LS_TRADING_HEIGHT);
  if (value) {
    return Math.max(300, Number(value));
  } else {
    return '50%';
  }
};

const Trading = () => {
  const chain = useSelector((state: IStore) => state.current.chain);
  const layout = useSelector((state: IStore) => state.layout);

  const { isMobile } = useDevice();
  const height = isMobile || !layout.info ? '100%' : getSavedHeight();

  if (!chain) {
    return <TradingPlaceholder text={cexTradingPlaceholder} height={height} />;
  }

  const networkId = Network.fromChain(chain)?.toDecimal();
  const { isEVM, isElrond } = getNetworkFlags(networkId);

  const isTradingSupported =
    networkId &&
    ((isEVM && supportedEVMTradingChains.includes(networkId)) || isElrond);

  if (isTradingSupported) {
    return <DexTrading height={height} />;
  }

  return <TradingPlaceholder text={elrondTronPlacholder} height={height} />;
};

export default Trading;
